import Skeleton from '@mui/material/Skeleton';
import { StyledSkeletonTable } from 'pages/Monitoring/OrderProviderExternalErrors/OrderProviderExternalErrorsSummary/OrderProviderExternalErrorsSummary.styled';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TableBody, TableCell, TableCellHeader, TableHead, TableRow } from 'shared/mui/Table';

export const OrderProviderExternalErrorsSummaryGatewaysDialogSkeleton: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <StyledSkeletonTable>
      <TableHead>
        <TableRow>
          <TableCellHeader
            label={translate('app.orderProviderExternalErrors.datagrid.declineReason')}
          />
          <TableCellHeader
            label={translate('app.orderProviderExternalErrors.datagrid.numberOfOrdersWithReason')}
          />
          <TableCellHeader
            label={translate(
              'app.orderProviderExternalErrors.datagrid.percentOfDeclinesForSelectedPeriod',
            )}
          />
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: 5 }).map((_, index) => (
          <TableRow key={index}>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton variant="text" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StyledSkeletonTable>
  );
};
